import * as types from "./types";

export const actions = (dispatch) => ({
  updateContactMessages: (messages) => {
    dispatch({
      type: types.UPDATE_CONTACT_MESSAGES,
      messages: messages,
    });
  },
  updateCurrentContact: (contact) => {
    dispatch({
      type: types.CURRENT_CONTACT_UPDATE,
      contact: contact,
    });
  },

  setSpotlight: (spotlight) => {
    dispatch({
      type: types.SET_SPOTLIGHT_UPDATE,
      spotlight: spotlight,
    });
  },

  setShowModal: (showModal) => {
    dispatch({
      type: types.SET_SHOW_MODAL,
      showModal: showModal,
    });
  },

  setPrevMedia: (prevMedia) => {
    dispatch({
      type: types.PREV_MEDIA,
      prevMedia: prevMedia,
    });
  },

  setCurrentMedia: (currentMedia) => {
    dispatch({
      type: types.CURRENT_MEDIA,
      currentMedia: currentMedia,
    });
  },
});
